import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  fetchCondominiums,
  findOneConfig,
  remove,
} from "../../helpers/api/condominium";
import FalconCardHeader from "../common/FalconCardHeader";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  CardFooter,
  Label,
  ListGroup,
} from "reactstrap";
import { isIterableArray } from "../../helpers/utils";
import FullPagination from "../common/pagination/FullPagination";
import ListItem from "../common/ListItem";
import { Toast } from "../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import ButtonIcon from "../common/ButtonIcon";
import { faExclamation, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { SelectCondominium } from "../../actions/condominiumActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PreloadState, Or, Message } from "../UI/preloading/PreloadState";
import classNames from "classnames";
import Swal from "sweetalert2";
import Flex from "../common/Flex";
import { findMyServicesAsManager } from "../../helpers/api/finance";
import ModalSelectedMoneyType from "./components/ModalSelectedMoneyType";
import usePagination from "./../../hooks/usePagination";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getFile } from "../../utils/digitalOcean/digitalocean-upload-file";
import { setCurr } from "../../actions/authActions";
import { fetchWithAuthorization } from "../../helpers/api/fetch";

const CondominiumList = () => {
  //
  const history = useHistory();
  const dispatch = useDispatch();
  const pagination = usePagination();

  const selectedCondominium = useSelector(
    (state) => state.condominium.selectedCondominium,
    shallowEqual
  );
  const { token } = useSelector((state) => state?.auth?.user);
  const { currency } = useSelector((state) => state.auth);

  const [tempSearch, setTempSearch] = useState("");
  const [openModalSelectMoney, setOpenModalSelectMoney] = useState(false);
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);

  const [filter, setFilter] = useState({
    search: "",
    banned: "all",
    from: null,
    to: null,
  });

  const handleDelete = async (condominiumId) => {
    try {
      await remove(condominiumId);
      loadCondominiums();
      Toast.fire({
        type: "success",
        title: "Condominio eliminado satisfactoriamente.",
      });
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  const isSelectedCondominium = async (condominium) => {
    try {
      const data4 = await fetchWithAuthorization(
        `/condominium/config/${condominium.condominium_id}`
      );

      if (data4) {
        dispatch(setCurr(data4.data.currency_id));
      } else {
        dispatch(setCurr(""));
      }

      dispatch(
        SelectCondominium(
          condominium.condominium_id,
          condominium.name,
          condominium.address,
          condominium.identification
        )
      );
    } catch (error) {
      console.error("Error al obtener la configuración del condominio:", error);
    }
  };

  const notPermission = () => {
    Swal.fire({
      text: "Para seguir disfrutando del servicio, debes estar mantenerte solvente.",
      confirmButtonText: "Ok, entiendo.",
      confirmButtonColor: "#950ec3",
      html: `<p>Para seguir disfrutando del  <strong class='text-primary'>servicio</strong>, debes mantenerte solvente.</p>`,
    });
  };

  const ListCondominiumGroup = ({ data }) => {
    const no_photo =
      "https://static.vecteezy.com/system/resources/previews/004/141/669/non_2x/no-photo-or-blank-image-icon-loading-images-or-missing-image-mark-image-not-available-or-image-coming-soon-sign-simple-nature-silhouette-in-frame-isolated-illustration-vector.jpg";
    return (
      <ListGroup style={{ gap: "10px" }}>
        {data &&
          data.map((condominium, i) => {
            return (
              <ListItem
                onClick={() =>
                  Boolean(true)
                    ? isSelectedCondominium(condominium)
                    : notPermission()
                }
                avatar={
                  condominium?.config?.logo
                    ? getFile(condominium?.config?.logo)
                    : no_photo
                }
                key={i}
                options={selectedCondominium === condominium.condominium_id}
                title={condominium.name}
                status={condominium.status}
                solved={condominium.banned}
                acronym={condominium.acronym}
                alternativeName={"condominio"}
                id={condominium.condominium_id}
                createdAt={condominium.created_at}
                condominiumId={condominium.condominium_id}
                onChangeMoney={() => setOpenModalSelectMoney(true)}
                onEditAction={() =>
                  history.push(
                    `/dashboard/condominiums/${condominium.condominium_id}`
                  )
                }
                onSeeAction={() => handleSeeBanks(condominium.condominium_id)}
                onDeleteAction={() => handleDelete(condominium.condominium_id)}
              />
            );
          })}
      </ListGroup>
    );
  };

  const handleSeeBanks = (condominiumId) => {
    history.push(`/dashboard/banks/${condominiumId}`);
    /*  setRedirect(true); */
  };

  const loadCondominiums = async () => {
    setLoading(true);
    try {
      const response = await fetchCondominiums(pagination.page, pagination.limit, {
        search: filter.search,
        banned: filter.banned,
      });
      if (!response?.links) {
        setErrors(true);
        return;
      }
      setData(response?.data);
      pagination.setTotal(response?.meta?.total);
    } catch (error) {
      console.error("error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const servicesAsManager = async () => {
    if (!selectedCondominium) return;
    try {
      const data = await findMyServicesAsManager(1, 10, {
        selectedCondominium,
      });
      console.log("servicesAsManager: ", data);
      setServices(data);
    } catch (error) {
      console.error("error: ", error);
    }
  };

  useEffect(() => {
    servicesAsManager();
  }, [selectedCondominium]);

  useEffect(() => {
    loadCondominiums();
    // La página tiene que entrar en las dependencias: si no, buscar desde la
    // página 2 sigue pidiendo esa página y el resultado parece vacío.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, pagination.page, pagination.limit, selectedCondominium]);

  return (
    <>
      <Card className="mb-3">
        <CardBody>
          <FontAwesomeIcon icon={faExclamation} className="mr-2" />
          Haga click en un condominio para seleccionarlo y empezar a
          administrarlo.
        </CardBody>
      </Card>
      <Card>
        <FalconCardHeader title={"Listado de condominios"}>
          <Row className="mb-2">
            <Col className="pr-0">
              <Flex align="center">
                <Label className="mb-0 mr-2">Filtrar</Label>
                <Input
                  type="select"
                  onChange={({ target }) => {
                    pagination.setPage(1);
                    setFilter({
                      ...filter,
                      banned:
                        target.value === "true"
                          ? true
                          : target.value === "false"
                            ? false
                            : "all",
                    });
                  }}
                >
                  <option value="all">Todos</option>
                  <option value={false}>Activos</option>
                  <option value={true}>Desactivados</option>
                </Input>
              </Flex>
            </Col>
            <Col
              xs={12}
              md={"auto"}
              className="mt-3 mt-md-0 text-center text-md-right"
            >
              <ButtonIcon
                onClick={() => {
                  history.push(`/dashboard/condominiums/create`);
                }}
                icon={"plus"}
                color={"falcon-default"}
              >
                Añadir condominio{" "}
              </ButtonIcon>
            </Col>
          </Row>
          <Row>
            <Col className="d-flex">
              <Input
                type="text"
                value={tempSearch}
                onChange={(e) => {
                  const value = e.target.value;
                  setTempSearch(value);
                  if (value.trim() === "") {
                    pagination.setPage(1);
                    setFilter({ ...filter, search: null });
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key !== "Enter") return;
                  const value = e.currentTarget.value.trim();
                  setTempSearch(value);
                  pagination.setPage(1);
                  setFilter({ ...filter, search: value || null });
                }}
                placeholder="Nombre, sigla, identificación o dirección..."
                className="d-inline-block search-input mr-2"
              />
              <Button
                className="d-inline-block"
                color={"falcon-default"}
                onClick={() => {
                  const value = tempSearch.trim();
                  setTempSearch(value);
                  pagination.setPage(1);
                  setFilter({ ...filter, search: value || null });
                }}
              >
                Buscar
              </Button>
            </Col>
          </Row>
        </FalconCardHeader>
        <CardBody
          className={classNames("fs--1", { "p-0": isIterableArray(data) })}
        >
          <PreloadState loading={loading} cond={isIterableArray(data)}>
            <Or value={true}>
              <ListCondominiumGroup data={data} />
            </Or>
            <Or value={false} cond={Boolean(errors)}>
              <Or value={false} cond={Boolean(tempSearch)}>
                <Message
                  value={true}
                  align="left"
                  color={"info"}
                  className="p-3"
                  icon={faInfoCircle}
                >
                  <>
                    No hemos encontrado un condominio con el nombre "
                    {tempSearch}".
                  </>
                </Message>
                <Message
                  align="left"
                  value={false}
                  color={"info"}
                  className="p-3"
                  icon={faInfoCircle}
                >
                  <>
                    Al parecer aún no has creado un condominio, Puedes crear uno
                    ahora mismo pulsando el siguiente enlace
                    <Button
                      size="sm"
                      color="link"
                      data-testid="Button"
                      className="pl-0 ml-1"
                      onClick={() =>
                        history.push("/dashboard/condominiums/create")
                      }
                    >
                      Crear condominio
                    </Button>
                  </>
                </Message>
              </Or>
            </Or>
          </PreloadState>
        </CardBody>
        <CardFooter>
          {isIterableArray(data) && (
            <FullPagination
              nextPage={() => pagination.setPage(pagination.page + 1)}
              prevPage={() => pagination.setPage(pagination.page - 1)}
              goToPage={(e) => pagination.setPage(e)}
              meta={{
                currentPage: pagination.page,
                lastPage: Math.max(
                  1,
                  Math.ceil((pagination.total || 0) / (pagination.limit || 10))
                ),
                total: pagination.total,
                perPage: pagination.limit,
              }}
              className={"shadow-none"}
              posText={"condominios"}
              perPage={pagination.setLimit}
            />
          )}
        </CardFooter>
      </Card>
      <ModalSelectedMoneyType
        open={openModalSelectMoney}
        toggle={() => setOpenModalSelectMoney(false)}
      />
    </>
  );
};

export default CondominiumList;
